import { render, staticRenderFns } from "./campaignsDetails.vue?vue&type=template&id=55a532a2&"
import script from "./campaignsDetails.vue?vue&type=script&lang=js&"
export * from "./campaignsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports